import 'babel-polyfill'
import Vue from 'vue'
import App from './App'

import router from './router'
import fastclick from 'fastclick'
fastclick.attach(document.body)

Vue.config.productionTip = false

import './common/css/index.css'

import VueLazyload from 'vue-lazyload'
Vue.use(VueLazyload, {
  preLoad: 1.3, //提前加载高度（数字 1 表示 1 屏的高度）
  // error: 'dist/error.png', //图片加载失败时显示的图片
  // loading: 'dist/loading.gif', //图片加载状态下显示的图片
  attempt: 1 //加载错误后最大尝试次数
})

import preview from "vue-photo-preview";
import "vue-photo-preview/dist/skin.css";
let option = {
  maxSpreadZoom: 1, // 控制预览图最大的倍数，默认是2倍，我这里改成了原图
 fullscreenEl: true, //控制是否显示右上角全屏按钮
  closeEl: true, //控制是否显示右上角关闭按钮
  tapToClose: true, //点击滑动区域应关闭图库
  shareEl: false, //控制是否显示分享按钮
  zoomEl: true, //控制是否显示放大缩小按钮
  counterEl: false, //控制是否显示左上角图片数量按钮
  arrowEl: false,  //控制如图的左右箭头（pc浏览器模拟手机时）
  tapToToggleControls: false, //点击应切换控件的可见性
  clickToCloseNonZoomable: true //点击图片应关闭图库，仅当图像小于视口的大小时
}
Vue.use(preview, option);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  // vueSwiper,
  router,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js